import Calculator from "./Components/Calculator";

function App() {
  return (
    <>
      <div className="App d-flex align-items-center justify-content-center">
        <Calculator />
      </div>
    </>
  );
}

export default App;
